var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-con"},[_c('Card',{attrs:{"icon":"log-in","title":"欢迎登录","bordered":false}},[_c('div',{staticClass:"form-con"},[_c('login-form'),_c('p',{staticClass:"login-tip"})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }